// Horas autorizadas por semana para la planificación de turnos (módulo administrativo).

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const BASE = `${API_URL}/horas-autorizadas`;

const handleResponse = async (response, errorMsg) => {
  const text = await response.text().catch(() => '');
  let json = null;
  try { json = text ? JSON.parse(text) : null; } catch (_) { /* texto plano */ }
  if (!response.ok || json?.state === false) {
    const message = Array.isArray(json?.message) ? json.message.join(', ') : json?.message || text || response.statusText;
    throw new Error(message || errorMsg);
  }
  return json?.data;
};

const jsonInit = (method, body) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export const listarHorasCentros = async (weekStart) =>
  handleResponse(await fetch(`${BASE}/centros?weekStart=${weekStart}`), 'Error al obtener las horas autorizadas');

export const obtenerResumenSemana = async (laundryCenterId, weekStart) =>
  handleResponse(
    await fetch(`${BASE}/resumen?laundryCenterId=${laundryCenterId}&weekStart=${weekStart}`),
    'Error al obtener las horas autorizadas del centro',
  );

// limiteSemanal vacío/null = quitar el límite estándar
export const guardarLimiteEstandar = async (laundryId, limiteSemanal, usuario) =>
  handleResponse(
    await fetch(`${BASE}/centros/${laundryId}`, jsonInit('PUT', { limiteSemanal, usuario })),
    'Error al guardar el límite semanal',
  );

export const autorizarHorasSemana = async ({ laundryCenterId, weekStart, horas, motivo, usuario }) =>
  handleResponse(
    await fetch(`${BASE}/semanas`, jsonInit('PUT', { laundryCenterId, weekStart, horas, motivo, usuario })),
    'Error al autorizar las horas de la semana',
  );

// Restricción del registro de llegada del centro: modo 'apagado' | 'aviso' | 'bloqueo' y
// cuántos minutos antes del turno se puede marcar
export const guardarRestriccionLlegada = async (laundryId, { modo, minutosAntes }, usuario) =>
  handleResponse(
    await fetch(`${BASE}/restriccion-llegada/${laundryId}`, jsonInit('PUT', { modo, minutosAntes, usuario })),
    'Error al guardar la restricción de llegada',
  );

// Últimas `semanas` semanas del centro hasta la semana `hasta` (lunes): planeadas vs. ejecutadas
// (mismas reglas del informe "Horas del mes") y las horas autorizadas de cada semana
export const obtenerSemanasCentro = async (laundryCenterId, hasta, semanas = 4) =>
  handleResponse(
    await fetch(`${API_URL}/dashboard/semanas-centro/${laundryCenterId}?hasta=${hasta}&semanas=${semanas}`),
    'Error al obtener las semanas del centro',
  );

export const quitarAjusteSemana = async (laundryCenterId, weekStart) =>
  handleResponse(
    await fetch(`${BASE}/semanas?laundryCenterId=${laundryCenterId}&weekStart=${weekStart}`, { method: 'DELETE' }),
    'Error al quitar el ajuste de la semana',
  );
